import React from 'react';

function Footer() {
    return (
        <>
            <footer className="bg-light text-center my-footer">
                <p>&copy; Suleman. All Rights Reserved - Terms and Conditions </p>
            </footer>

        </>

    )
}

export default Footer;
